import { useLayoutEffect } from "react";

const useBlockScroll = (shouldBlock, backToCurrentPosition = true) => {
	useLayoutEffect(() => {
		if (!shouldBlock) {
			return;
		}

		if (typeof window === "undefined" || typeof document === "undefined") {
			return;
		}

		const y = window.scrollY || 0;
		const scrollbarComp = window.innerWidth - document.documentElement.clientWidth;

		if (scrollbarComp > 0) {
			const currentPad = parseFloat(getComputedStyle(document.body).paddingRight) || 0;
			document.body.style.paddingRight = `${currentPad + scrollbarComp}px`;
		}

		document.body.style.position = "fixed";
		document.body.style.top = `-${y}px`;
		document.body.style.left = "0";
		document.body.style.right = "0";
		document.body.style.width = "100%";
		document.body.style.overflow = "hidden";

		// eslint-disable-next-line
		return () => {
			const top = document.body.style.top;

			document.body.style.removeProperty("position");
			document.body.style.removeProperty("top");
			document.body.style.removeProperty("left");
			document.body.style.removeProperty("right");
			document.body.style.removeProperty("width");
			document.body.style.removeProperty("overflow");
			document.body.style.removeProperty("padding-right");

			if (backToCurrentPosition) {
				const yPrev = Math.abs(parseInt(top || "0", 10)) || 0;
				window.scrollTo(0, yPrev);
			}
		};
	}, [shouldBlock, backToCurrentPosition]);
};

export default useBlockScroll;
